/** productionTpoBack (DigitalOcean) — shop API host */
export const DIGITAL_APP_BASE =
  'https://king-prawn-app-ugsdt.ondigitalocean.app'
